import type { FolderContents, LibraryObject } from "./model";
import { apiQuery } from "utils/queries";
import S3LibraryStore from "./S3LibraryStore";

/**
 * The authoring side of the library: folders and files as they sit in S3, which is
 * where content lives until a version is published. Everything a reader sees comes
 * from the API in `./index` instead.
 */
const s3LibraryStore = new S3LibraryStore();

export const folderContentsQuery = apiQuery<FolderContents, { key: string }>({
  key: "folder-contents",
  queryFn: ({ params }) => listFolderContents(params),
});

function listFolderContents(args: { key: string; maxNumberOfKeys?: number }) {
  return s3LibraryStore.listFolderContents(args.key, args.maxNumberOfKeys);
}

export function createFolder(newObject: LibraryObject, parentKey: string) {
  return s3LibraryStore.createFolder(newObject, parentKey);
}

export function updateFolderMetadata(object: LibraryObject) {
  return s3LibraryStore.updateFolderMetadata(object);
}

export function renameFolder(object: LibraryObject) {
  return s3LibraryStore.renameFolder(object);
}

export function removeFolder(args: { key: string }) {
  return s3LibraryStore.removeFolder(args.key);
}

export function createFile(
  newObject: LibraryObject,
  parentKey: string,
  contentFiles: globalThis.File[],
  assetFiles?: globalThis.File[]
) {
  return s3LibraryStore.createFile(newObject, parentKey, contentFiles, assetFiles ?? []);
}

// The stored object behind a folder key: its metadata carries the library object the
// folder stands for.
export function fetchStoredObjectMetadata(key: string) {
  return s3LibraryStore.fetchObjectMetadata(key);
}

export function clearLibraryStoreCredentials() {
  s3LibraryStore.clearCredentials();
}
